import { useState, useEffect } from "react";
import { getTasks } from "../../functions/getData";
import { populateTask, deepCopy } from "../../functions/edit";

export default function useEditTaskData(taskId) {
  const [loading, setLoading] = useState(true);
  const [firstLoaded, setFirstLoaded] = useState(false);
  const [original, setOriginal] = useState(undefined);
  const [task, setTask] = useState(undefined);
  const [editAnswers, setEditAnswers] = useState(false);

  useEffect(() => {
    if (!taskId) return;

    const controller = new AbortController();
    const { signal } = controller;

    getTasks(`?id=${taskId}`, signal)
      .then((c) => {
        setEditAnswers(c.taskLists.data[0].allow_update_answer);
        const foundTasks = populateTask(c.taskLists);
        setOriginal(deepCopy(foundTasks));
        setTask(foundTasks);
      })
      .catch((e) => {
        if (!signal.aborted) console.log(e);
      })
      .finally(() => {
        if (!signal.aborted) {
          setLoading(false);
          setFirstLoaded(true);
        }
      });

    return () => controller.abort();
  }, [taskId]);

  return {
    loading,
    firstLoaded,
    original,
    setOriginal,
    task,
    setTask,
    editAnswers,
  };
}
